/*
 * @Description: 
 * @Author: Lidya
 * @Date: 2022-07-26 15:48:15
 * @LastEditors: Lidya
 * @LastEditTime: 2023-01-04 10:30:42
 */
module.exports = {
    licence:{
        Robot_problem_solved:'Helpful',
        Robot_problem_unsolved:"Didn't Help",
        Robot_emptyMassege_reminder:"Can't Send Empty Message",
        Robot_massege_ViewMore:'View More',
        Robot_massege_ViewLess:'View Less',
        Robot_greetings_1:'Hey, what can I do for you today?',
        Robot_greetings_2:'Looking for something else? Try entering a keyword so I can check for more info to help you out!',
        // Robot_closing_1_1:"Aww, sorry! I'm still learning. ",
        Robot_closing_1_1:"Oops!Sorry, I didn't understand your question.",
        // Robot_closing_1_2:"Please try using another keyword, or simply click   ",
        Robot_closing_1_2:"Please rephrase it or click the button below to get further help. Also, you can click   ",
        Robot_closing_1_login_1:"Aww, sorry! I'm still learning. ",
        Robot_closing_1_login_2:'Please try using another keyword!',
        Robot_closing_2:'HERE ',
        // Robot_closing_3:'and Contact our Support Team. We will get back to you ASAP!',
        Robot_closing_3:'to contact our Support Team.',
        Robot_problem_unsolved_reply:"Sorry,we couldn't help more this time. I've written down your request so that we can improve our Support in the future! Please click HERE and Contact our Support Team. We will get back to you ASAP!",
        Robot_TypeHere:'Type Here',
        Robot_greetings_label1:'Merge data to new APP',
        Robot_greetings_label2:'Data are missing after migration',
        Robot_greetings_label3:'Scale is disconnected after migration',
        Robot_greetings_label4:'Tips after migration',
        Robot_greetings_label5:'Graphics shown in the card',
        Robot_greetings_label6:"View weight history",
        Robot_greetings_label7:"View circumference history",
        Robot_greetings_label8:'Where can I get help',
        Robot_greetings_label9:'Others',
        key_internet_error:'There are issues with the network. Please check your network settings',
        Robot_title_Beta:'ChatBot',
        Robot_greetings_label1_login:'Forget the password',
        Robot_greetings_label2_login:'How to reset the password',
        Robot_greetings_label3_login:'Merge data to new APP',
        Robot_greetings_label4_login:'Why are there two APPs',
        Robot_greetings_label5_login:'Notes for account login',
        Robot_greetings_label6_login:"Does the new APP need new registration",
        Robot_greetings_label7_login:"What to do if I have account on both APPs",
        Robot_greetings_label8_login:'Where can I get help',
        Robot_greetings_label9_login:'Others',
        Robot_greetings_label1_devicePage:'Ways to add a device',
        Robot_greetings_label2_devicePage:'Add device via the "Add Device Popup"',
        Robot_greetings_label3_devicePage:'Add device manually',
        Robot_greetings_label4_devicePage:'Tips for pairing Wifi-Bluetooth scale',
        Robot_greetings_label5_devicePage:'How to pair Wifi',
        Robot_greetings_label6_devicePage:"Device is not listed under 'PAIRED DEVICES'",
        Robot_greetings_label7_devicePage:"Delete a device",
        Robot_greetings_label8_devicePage:'Where can I get help',
        Robot_greetings_label9_devicePage:'Others',
        Robot_greetings_label1_mePage:'Can I change the primary user',
        Robot_greetings_label2_mePage:"How to edit the primary user's information",
        Robot_greetings_label3_mePage:"View friend's data",
        Robot_greetings_label4_mePage:'Add a friend',
        Robot_greetings_label5_mePage:'How to send the friend request',
        Robot_greetings_label6_mePage:"How to check the friend request",
        Robot_greetings_label7_mePage:"Delete a friend",
        Robot_greetings_label8_mePage:'Where can I get help',
        Robot_greetings_label9_mePage:'Others',
        Robot_greetings_label1_balancePage:'Weight data do not sync to APP',
        Robot_greetings_label2_balancePage:'How to check the Bluetooth error',
        Robot_greetings_label3_balancePage:'APP displays weight&BMI only',
        Robot_greetings_label4_balancePage:'Muscle readings display in "--"',
        Robot_greetings_label5_balancePage:'The scale weighs incorrectly',
        Robot_greetings_label6_balancePage:"The body fat% reading changes drastically",
        Robot_greetings_label7_balancePage:"Input weight data manually",
        Robot_greetings_label8_balancePage:'Switch to another measurement user',
        Robot_greetings_label9_balancePage:'Others',
        Robot_greetings_label1_tapPage:'How to use the tape measure',
        Robot_greetings_label2_tapPage:'Switch to another measurement user',
        Robot_greetings_label3_tapPage:'View circumference trends graph',
        Robot_greetings_label4_tapPage:'View circumference history',
        Robot_greetings_label5_tapPage:'Input circumference data manually',
        Robot_greetings_label6_tapPage:"Where can I get help",
        Robot_greetings_label7_tapPage:"Others",
        savetoAlbum: 'Saved to Album',
        key_cancel: 'Cancel',
        key_confirm: 'Confirm',
        key_deleted: 'Successfully deleted',
        key_delete_popup: 'History will not be recovered after deletion, please make sure you want to delete it.',
        key_delete_history: 'Delete Chat History',
        key_delete_confirmation: 'Delete Confirmation'
    }
}